<div>
  Test Component
</div>
<div>
  <wl-date-selector name="startDate" [(ngModel)]="startDate" (onDateChanged)="selectedDateChange()"></wl-date-selector>
</div>
<!--
<div>
    <button pButton type="button" (click)="getData()">http</button>
</div>
<div>
  <button pButton type="button" (click)="getAuth()">Auth</button>
</div>
<div>
  <button pButton type="button" (click)="getApi('get')">Get</button>
</div>
<div>
  <button pButton type="button" (click)="getApi('post')">Post</button>
</div>
<div>
  <button pButton type="button" (click)="getApi('put')">Put</button>
</div>
<div>
  <button pButton type="button" (click)="getApi('delete')">Delete</button>
</div>
<div>
 </div>
    -->
<div>
  <button pButton type="button" (click)="GetRandomText()">Get Random Text</button>
</div>
<br />
<br />
<div>
  <button pButton type="button" (click)="GetRandomText2()">Get Random Text 2</button>
</div>
<br />
<br />
<div>
  <button pButton type="button" (click)="GetRandomText3()">Get Random Text 3</button>
</div>
<br />
<br />
<div>{{ output }}</div>
